module.exports = __webpack_public_path__ + "img/explainer-8.26feda05.jpg";